import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailFeatures {
  bathrooms: number | null;
  bedrooms: number | null;
  floorLevel: number | null;
  floorsTotal: number | null;
  sqmLand: string | null;
  sqmConstruction: string | null;
  pumps: number | null;
  parkingSpots: number | null;
  halfBathrooms: number | null;
}

export const prepareDetailPropertyFeatures = (
  data: IPropertyDetailsResponse
): IPropertyDetailFeatures => {
  return {
    bathrooms: data?.bathrooms || null,
    bedrooms: data?.bedrooms || null,
    floorLevel: data?.floor_level || null,
    floorsTotal: data?.floors_total || null,
    sqmLand: data?.sqm_land || null,
    sqmConstruction: data?.sqm_construction || null,
    pumps: data?.pumps || null,
    parkingSpots: data?.parking_spots || null,
    halfBathrooms: data?.half_bathrooms || null
  };
};
